module.exports = __webpack_public_path__ + "static/media/thanks-main.3e43311f.png";